import type { SyncTask } from '../../api/admin.api';

/** What each sync does and when it runs on its own, in the words the page shows beside its button. */
export const SYNC_TASKS: { task: SyncTask; label: string; description: string; schedule: string }[] = [
  {
    task: 'resync',
    label: 'Catalog from Confluence',
    description: 'Reads the SDLC catalog from Confluence. The other syncs link to it, so it runs first.',
    schedule: 'Nightly, 02:00 UTC',
  },
  {
    task: 'load-agents',
    label: 'Agent files in the toolkit repository',
    description: 'Loads the agents kept in this repository into the library.',
    schedule: 'Nightly, 02:15 UTC',
  },
  {
    task: 'sync-prompts',
    label: 'Prompt Library',
    description: 'Publishes approved prompts from Prompt Library.',
    schedule: 'Nightly, 02:20 UTC',
  },
  {
    task: 'sync-git-sources',
    label: 'Git repositories',
    description: 'Imports each repository\'s new releases. Each repository below has a button of its own.',
    schedule: 'Nightly, 02:25 UTC',
  },
  {
    task: 'export-docs',
    label: 'Google Docs export',
    description: 'Writes the catalog out to Google Docs.',
    schedule: 'Nightly, 02:30 UTC',
  },
];
